export default __webpack_public_path__ + "static/media/Benefits4.cbf49004.bin";